import React, { Component } from 'react'
import PlusSvg from '../icons/PlusSvg';
import MinusSvg from '../icons/MinusSvg';

export class Faq extends Component {
    state = {
        visible: false
    }
    render() {
        const { visible } = this.state;
        const { question, answer } = this.props;
        return (


            <div className='rounded-[8px]'>
                <div onClick={() => this.setState({ visible: !visible })} className='flex items-center  gap-[16px] bg-[#f4f8fc] rounded-[8px] p-[8px] cursor-pointer' >
                    <div>
                        {!visible ?
                            <PlusSvg /> : <MinusSvg />
                        }
                    </div>

                    <h3 className='text-[20px] font-[600] text-[var(--black)] max-[450px]:text-[17px]'>{question}</h3>
                </div>
                {visible ?
                    <p className='mt-[8px] text-[16px] font-[400] mb-[15px] text-[var(--dark-gray)] ml-[18px] mr-[4px] max-[450px]:text-[14px]'> {answer}</p> : null
                }
            </div>


        )
    }
}

export default Faq